import type { AppConfigInput } from 'nuxt/schema'

export default {
  accordion: {
    slots: {
      item: 'border-none',
      trigger: 'py-2 cursor-pointer',
      trailingIcon: 'group-data-[state=open]:rotate-0',
    },
  },
} as AppConfigInput['ui']
